module.exports = {
  validateState(obj, name) {
    const { $dirty, $error } = obj[name];
    let state = $dirty ? !$error : null;

    return state;
  },
};
